import {Component, effect, inject, signal} from '@angular/core';
import {NgClass} from "@angular/common";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {AggregatedAssetStateStore} from 'src/app/domain/assets/aggregated-state/aggregated-asset-state.store';
import {AnimalsStore} from 'src/app/domain/assets/animals/animals.store';
import {RoutingService} from 'src/app/infrastructure/routing/routing.service';
import {MainViewStore} from 'src/app/presentation/main-view/main-view.store';
import {Animal} from 'src/app/infrastructure/moovement-api/models/asset';
import {
  fiftyFiveMinutes,
  fiftyMinutes,
  fourtyFiveMinutes,
  fourtyMinutes,
  thirtyFiveMinutes,
  thirtyMinutes,
  twoHours
} from 'src/app/presentation/common/globals';
import {
  ScheduledAnimalsComponent
} from "src/app/presentation/main-view/information-center/animals/animal-ping-schedule/scheduled-animals/scheduled-animals.component";

@Component({
  selector: 'app-animals',
  imports: [
    NgClass,
    ScheduledAnimalsComponent
],
  templateUrl: './animal-ping-schedule.component.html',
  styleUrl: './animal-ping-schedule.component.css'
})
export class AnimalPingScheduleComponent {

  outOfSchedule = signal<Animal[]>([]);
  zeroToFiveMinutes = signal<Animal[]>([]);
  fiveToTenMinutes = signal<Animal[]>([]);
  tenToFifteenMinutes = signal<Animal[]>([]);
  fifteenToTwentyMinutes = signal<Animal[]>([]);
  twentyToTwentyFiveMinutes = signal<Animal[]>([]);
  twentyFiveToThirtyMinutes = signal<Animal[]>([]);
  moreThanThirtyMinutes = signal<Animal[]>([]);

  filterValue = signal('');

  private aggregatedAssetStateStore = inject(AggregatedAssetStateStore);
  private animalsStore = inject(AnimalsStore);
  private mainViewStore = inject(MainViewStore);

  constructor(
    protected routingService: RoutingService,
    protected viewportService: ViewportService
  ) {
    effect(() => {
      if (this.aggregatedAssetStateStore.loading() || this.animalsStore.loading()) return;

      const now = Date.now();
      const twoHoursAgo = new Date(now - twoHours);
      const fiftyFiveMinutesAgo = new Date(now - fiftyFiveMinutes);
      const fiftyMinutesAgo = new Date(now - fiftyMinutes);
      const fortyFiveMinutesAgo = new Date(now - fourtyFiveMinutes);
      const fourtyMinutesAgo = new Date(now - fourtyMinutes);
      const thirtyFiveMinutesAgo = new Date(now - thirtyFiveMinutes);
      const thirtyMinutesAgo = new Date(now - thirtyMinutes);

      const outOfSchedule: Animal[] = [];
      const zeroToFiveMinutes: Animal[] = [];
      const fiveToTenMinutes: Animal[] = [];
      const tenToFifteenMinutes: Animal[] = [];
      const fifteenToTwentyMinutes: Animal[] = [];
      const twentyToTwentyFiveMinutes: Animal[] = [];
      const twentyFiveToThirtyMinutes: Animal[] = [];
      const moreThanThirtyMinutes: Animal[] = [];

      const filterValue = this.filterValue();
      const filteredAnimals = this.animalsStore.entities().filter(animal => {
        return animal.name?.toLowerCase().includes(filterValue);
      });

      for (const animal of filteredAnimals) {
        const state = this.aggregatedAssetStateStore.entityMap()[animal.id];
        if (!state || !state.lastGPSFixAt) continue;

        if (state.lastGPSFixAt < twoHoursAgo) {
          outOfSchedule.push(animal);
        } else if (state.lastGPSFixAt < fiftyFiveMinutesAgo) {
          zeroToFiveMinutes.push(animal);
        } else if (state.lastGPSFixAt < fiftyMinutesAgo) {
          fiveToTenMinutes.push(animal);
        } else if (state.lastGPSFixAt < fortyFiveMinutesAgo) {
          tenToFifteenMinutes.push(animal);
        } else if (state.lastGPSFixAt < fourtyMinutesAgo) {
          fifteenToTwentyMinutes.push(animal);
        } else if (state.lastGPSFixAt < thirtyFiveMinutesAgo) {
          twentyToTwentyFiveMinutes.push(animal);
        } else if (state.lastGPSFixAt < thirtyMinutesAgo) {
          twentyFiveToThirtyMinutes.push(animal);
        } else {
          moreThanThirtyMinutes.push(animal);
        }
      }

      this.outOfSchedule.set(outOfSchedule);
      this.zeroToFiveMinutes.set(zeroToFiveMinutes);
      this.fiveToTenMinutes.set(fiveToTenMinutes);
      this.tenToFifteenMinutes.set(tenToFifteenMinutes);
      this.fifteenToTwentyMinutes.set(fifteenToTwentyMinutes);
      this.twentyToTwentyFiveMinutes.set(twentyToTwentyFiveMinutes);
      this.twentyFiveToThirtyMinutes.set(twentyFiveToThirtyMinutes);
      this.moreThanThirtyMinutes.set(moreThanThirtyMinutes);
    });
  }

  close() {
    this.mainViewStore.hideChildComponent();
  }

  filterResults(event: Event) {
    const value = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.filterValue.set(value);
  }
}
